export default __webpack_public_path__ + "static/media/TERMINOS-DE-USO-DEL-PRODUCTO-Y-DEL-SITIO-WEB-CONTROL-B.a078e6db.pdf";